<script>
import NavBar from '@components/layout/nav-bar'
export default {
  components: { NavBar }
}
</script>

<template>
  <v-layout style="height: 100%">
    <NavBar />
    <v-main>
      <slot />
    </v-main>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/router/layouts/main.vue